// PostHog must initialise BEFORE any application module mounts so its
// global exception handler sees every runtime error. Keep this as the
// first import — moving it below other imports defeats the purpose.
import { posthog } from "./instrument";
// Catches the browser's one-time install prompt before anything mounts, so "Install the app" can use it later.
import "@/shared/pwa/pwa-install";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PostHogProvider } from "@posthog/react";

import App from "@/app/runtime-app";
import "@/app/globals.css";
import "@xyflow/react/dist/style.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// PostHogProvider is mounted unconditionally. When `posthog.init` was
// skipped by the production gate in `instrument.ts`, `usePostHog()`
// still returns the uninitialised client and `posthog?.capture(...)`
// calls no-op silently — so consumers don't need to gate themselves.
createRoot(rootElement).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>,
);
